export const manageUserStatus = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'block':
      return 2
    case 'delete':
      return 3
    case 'unblock':
      return 1
    default:
      return ''
  }
}
